import React from 'react';
import Hero from '../components/home/Hero';
import FeaturesSplit from '../components/home/FeaturesSplit';
import JobCategories from '../components/home/JobCategories';
import CallToAction from '../components/home/CallToAction';
import TrustElements from '../components/home/TrustElements';

const Home = () => {
  return (
    <div className="w-full">
      <Hero />
      <TrustElements />
      <FeaturesSplit />
      <JobCategories />
      <CallToAction />
    </div>
  );
};

export default Home;